<mat-slide-toggle
  #slideToggle
  (click)="handleClick($event)"
  [checked]="checked"></mat-slide-toggle>
